import { render, staticRenderFns } from "./noneLayout.vue?vue&type=template&id=1876a436"
import script from "./noneLayout.vue?vue&type=script&lang=js"
export * from "./noneLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1876a436')) {
      api.createRecord('1876a436', component.options)
    } else {
      api.reload('1876a436', component.options)
    }
    module.hot.accept("./noneLayout.vue?vue&type=template&id=1876a436", function () {
      api.rerender('1876a436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/noneLayout.vue"
export default component.exports